<template>
  <v-checkbox
    @click.native.stop
    v-model="computedValue"
    :false-value="0"
    :true-value="1"
    hide-details=""
    v-bind="$attrs"
  ></v-checkbox>
</template>

<script>
import { get } from 'vuex-pathify';

export default {
  name: 'PermissionsCheckbox',
  props: {
    value: {
      type: Number,
      required: true,
    },
  },
  data: () => ({}),
  computed: {
    currentGroupPermissions: get('users/currentGroupPermissions'),
    computedValue: {
      get() {
        return this.value;
      },
      set(nV) {
        this.$emit('input', nV);
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.v-input--selection-controls {
  margin: 0px;
  padding: 0px;
  ::v-deep .v-input__slot {
    margin-bottom: 0;
  }
  ::v-deep .v-input--selection-controls__input {
    margin-right: 0;
  }
}
</style>
